import type { ColorPalette } from "types/theme";

/** Source of truth for the changelog markdown and its human-facing page. */
export const CHANGELOG_MD_URL =
  "https://www.tigerdata.com/docs/get-started/news/new/index.md";
export const CHANGELOG_DOCS_URL =
  "https://www.tigerdata.com/docs/get-started/news/new/";
/**
 * Pre-panel "What's new?" destination. The control group of EXP_WHATS_NEW
 * still opens this in a new tab; treatment gets the in-app WhatsNewPanel.
 */
export const LEGACY_CHANGELOG_URL =
  "https://docs.tigerdata.com/about/latest/changelog/";
/** Entry images in the markdown are root-relative (e.g. /docs/_astro/...). */
export const DOCS_ORIGIN = "https://www.tigerdata.com";

export type ChangelogTag = {
  label: string;
  colorPalette: ColorPalette;
};

/**
 * The fixed changelog taxonomy, taken verbatim from the filter legend at the top
 * of the source markdown. Each entry's tag line contains one or more of these
 * emoji; we map them to a text label + a Tag `colorPalette`.
 *
 * `ColorPalette` only offers neutral/highlight/success/warning/error, so several
 * categories share a palette — chosen to stay close to the Figma design.
 */
export const CHANGELOG_TAGS: Record<string, ChangelogTag> = {
  "✨": { label: "New Feature", colorPalette: "highlight" },
  "💡": { label: "Improvement", colorPalette: "highlight" },
  "🏎️": { label: "Performance", colorPalette: "success" },
  "🔐": { label: "Security", colorPalette: "warning" },
  "🔌": { label: "Integration", colorPalette: "neutral" },
  "🌍": { label: "Availability", colorPalette: "success" },
  "⚠️": { label: "Deprecation", colorPalette: "warning" },
  "🐛": { label: "Bug Fix", colorPalette: "error" },
  "🚨": { label: "Breaking", colorPalette: "error" },
  "🧪": { label: "Beta", colorPalette: "neutral" },
  "🎉": { label: "GA", colorPalette: "success" },
};
